// src/pages/UnderConstruction.js
import React from 'react';
import { FaTools } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import './UnderConstruction.css';

export default function UnderConstruction() {
  const { t } = useTranslation();

  return (
    <div className="under-construction-container">
      <div className="under-construction-card">
        <div className="icon-wrapper">
          <FaTools className="construction-icon" />
        </div>
        <h1 className="construction-title">
          {/* Use a reliable CDN for the UK flag emoji image */}
          <img
            src="https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/72x72/1f1ec-1f1e7.png"
            alt="UK flag"
            className="flag-icon"
          />
          {t('english_site_title', 'English Site')}
        </h1>
        <p className="construction-message">
          {t(
            'under_construction_message',
            'Sorry, this section is under construction. Please check back soon!'
          )}
        </p>
      </div>
    </div>
  );
}